/**
 * Los nueve catálogos, en un solo lugar.
 *
 * Están separados por archivo para que traducir uno no obligue a tocar los
 * otros ocho, y reunidos acá para que agregar un idioma sea una línea.
 * El test de paridad de claves lee este mismo mapa: si un catálogo se
 * queda corto, falla el test y no la pantalla de alguien.
 */
import type { SupportedLocale } from '@tennisup/contracts';

import es from './locales/es.json';
import en from './locales/en.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import de from './locales/de.json';
import pt from './locales/pt.json';
import zhCN from './locales/zh-CN.json';
import ko from './locales/ko.json';
import ja from './locales/ja.json';

export type Catalog = typeof es;

export const CATALOGS: Readonly<Record<SupportedLocale, Catalog>> = {
  es,
  en,
  fr,
  it,
  de,
  pt,
  'zh-CN': zhCN,
  ko,
  ja,
};
